/* ============================================================
   PC カスタマイズ選択肢 (pc-manager 同期版 / Globo 置き換え)
   - snippets/pc-customize-options.liquid が出力する [data-pc-customize] を初期化
   - 選択変更 → 合計表示 / form の hidden properties[軸名] を同期 / 公開 API とイベントを更新
   - product-form の submit を横取りし、本体 + 選択したアドオン variant を
     1 リクエスト (/cart/add.js の items[]) でカートに追加 → カートページへ遷移
   - 公開 API: window.SmolabCustomize (installment-bar.js / pc-spec-pdf.js / compare-product-page.js が参照)
   - イベント: document 上の CustomEvent 'smolab:customize:change'
   ============================================================ */
(function () {
  'use strict';

  // 課金対象 (非ベース = アドオン variant あり) だけに絞る。bindSubmit (モジュール直下) からも使うのでここに置く
  function nonBase(selection) {
    return selection.filter(function (s) { return s.variantId > 0; });
  }

  // 円×100 (Shopify の price 単位) → 円
  function toYen(cents) {
    return Math.round((parseInt(cents, 10) || 0) / 100);
  }

  // 日本円の簡易整形 (installment-bar.js の yen() と同じ 3 桁区切り + 先頭 ¥)
  function formatYen(yen) {
    return '¥' + Math.round(yen).toLocaleString('ja-JP');
  }

  // 表示中の価格要素 (Dawn の #price-<section>) から本体価格 (円×100) を読むフォールバック
  function readBasePriceFromDom(sectionId) {
    var wrap = sectionId ? document.getElementById('price-' + sectionId) : null;
    var scope = wrap || document;
    // セール中は販売価格を優先 (regular を先に見ると打ち消し線付きの割引前価格を拾う)
    var candidates = scope.querySelectorAll('.price__sale .price-item--sale, .price-item--sale, .price__regular .price-item--regular, .price-item--regular');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.offsetParent === null) continue; // 非表示はスキップ
      var text = (el.textContent || '').replace(/\s+/g, '');
      var m = text.match(/[¥￥]([\d,]+)/) || text.match(/([\d,]+)/);
      if (m) {
        var yen = parseInt(m[1].replace(/,/g, ''), 10);
        if (yen > 0) return yen * 100;
      }
    }
    return 0;
  }

  // 本体の product-form の <form> を特定する
  function findForm(root) {
    var sid = root.dataset.sectionId;
    var form = sid ? document.getElementById('product-form-' + sid) : null;
    if (form) return form;
    var section = root.closest('.shopify-section') || document;
    form = section.querySelector('product-form form') || section.querySelector('form[action*="/cart/add"]');
    if (form) return form;
    return document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
  }

  // 送信ロック (snippet の inline script が付ける) を解除する。bindSubmit 成功後だけ呼ぶ
  function unlockForm(form) {
    form.dataset.pczLocked = '0';
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.dataset.pczLock === '1') {
      delete btn.dataset.pczLock;
      if (btn.dataset.pczWasDisabled !== '1') btn.disabled = false;
      delete btn.dataset.pczWasDisabled;
    }
  }

  function showInitError(root, message) {
    var err = root.querySelector('[data-pcz-error]');
    if (err) { err.textContent = message; err.hidden = false; }
    root.classList.add('is-error');
  }

  function init(root) {
    if (root.dataset.pczBound === '1') return;
    root.dataset.pczBound = '1';
    try {
      initInner(root);
    } catch (e) {
      // 初期化に失敗したら送信ロックは解除しない (本体だけの購入を防ぐ) → 案内だけ出す
      console.error('[pc-customize] init failed', e);
      showInitError(root, 'カスタマイズ機能の初期化に失敗しました。ページを再読み込みしてください。');
    }
  }

  function initInner(root) {
    var form = findForm(root);
    if (!form) {
      console.warn('[pc-customize] product form が見つかりません。カート追加を止めます。');
      showInitError(root, 'カスタマイズ機能を初期化できませんでした。ページを再読み込みしてください。');
    }
    var productFormEl = form ? form.closest('product-form') : null;
    var sectionId = root.dataset.sectionId || (productFormEl && productFormEl.dataset.sectionId) || '';
    var productHandle = root.dataset.productHandle || '';
    var totalEl = root.querySelector('[data-smolab-total]');
    var extraEl = root.querySelector('[data-smolab-extra]');
    var basePriceCents = parseInt(root.dataset.basePrice, 10) || 0;

    // 動的チェックアウトが隠れるため「カートに追加」を primary 見た目に寄せる
    var submitButton = productFormEl
      ? productFormEl.querySelector('[type="submit"]')
      : (form ? form.querySelector('button[type="submit"]') : null);
    if (submitButton && submitButton.classList.contains('button--secondary')) {
      submitButton.classList.remove('button--secondary');
      submitButton.classList.add('button--primary');
    }
    if (form) {
      form.querySelectorAll('.shopify-payment-button').forEach(function (el) { el.style.display = 'none'; });
    }

    // ---- 選択状態の収集 ----
    // 戻り値: [{ axis, group(軸名), value(ラベル), price(円), priceCents, variantId, sku, isBase }]
    // ベース (変更なし) も含めて全軸を返す。カート/比較リストの明細には全軸を出し (「変更なし」も構成として表示)、
    // 課金・アドオン投入は variantId > 0 (非ベース) だけを使う
    function collectSelection() {
      var result = [];
      root.querySelectorAll('.pc-customize__axis').forEach(function (axisEl) {
        var picked = null;
        var select = axisEl.querySelector('select[data-smolab-axis]');
        if (select) {
          picked = select.options[select.selectedIndex] || null;
        } else {
          picked = axisEl.querySelector('input[type="radio"][data-smolab-axis]:checked');
        }
        if (!picked) return;
        var control = select || picked;
        var variantId = parseInt(picked.value, 10) || 0;
        var priceCents = variantId > 0 ? parseInt(picked.dataset.price, 10) || 0 : 0;
        var label = picked.dataset.label || (picked.textContent || '').trim();
        result.push({
          axis: control.dataset.smolabAxis || axisEl.dataset.axis || '',
          group: control.dataset.axisName || '',
          value: label,
          // カート/注文/比較リストの明細に出す表記: 課金選択肢は「ラベル（+¥14,000）」、ベースはラベルのみ
          display: variantId > 0 && priceCents > 0 ? label + '（+' + formatYen(toYen(priceCents)) + '）' : label,
          price: toYen(priceCents),
          priceCents: priceCents,
          variantId: variantId,
          sku: variantId > 0 ? picked.dataset.sku || '' : '',
          isBase: variantId === 0,
        });
      });
      return result;
    }


    function getBaseCents() {
      if (basePriceCents > 0) return basePriceCents;
      var fromDom = readBasePriceFromDom(sectionId);
      if (fromDom > 0) basePriceCents = fromDom;
      return basePriceCents;
    }

    function extraCents(selection) {
      return selection.reduce(function (sum, s) { return sum + s.priceCents; }, 0);
    }

    // ---- form の hidden input (properties[軸名] = ラベル) を同期 ----
    function syncHiddenInputs(selection) {
      if (!form) return;
      form.querySelectorAll('input[data-smolab-prop]').forEach(function (el) { el.remove(); });
      selection.forEach(function (s) {
        if (!s.group) return;
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[' + s.group + ']';
        input.value = s.display;
        input.setAttribute('data-smolab-prop', s.axis);
        form.appendChild(input);
      });
    }

    // ---- 合計表示と API 更新 ----
    function recalc() {
      var selection = collectSelection();
      var base = getBaseCents();
      var extra = extraCents(selection);
      if (totalEl) totalEl.textContent = formatYen(toYen(base + extra));
      if (extraEl) extraEl.textContent = extra > 0 ? '（+' + formatYen(toYen(extra)) + '）' : '';
      root.classList.toggle('has-extra', extra > 0);
      syncHiddenInputs(selection);
      document.dispatchEvent(new CustomEvent('smolab:customize:change', {
        detail: {
          selection: selection.map(function (s) { return { axis: s.axis, group: s.group, value: s.value, price: s.price, isBase: s.isBase }; }),
          baseYen: toYen(base),
          extraYen: toYen(extra),
          totalYen: toYen(base + extra),
        },
      }));
    }

    root.addEventListener('change', recalc);

    // Dawn のバリアント切替 (PC 商品は基本 1 variant だが保険)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      try {
        subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
          var variant = event && event.data && event.data.variant;
          if (variant && typeof variant.price === 'number' && variant.price > 0) {
            basePriceCents = variant.price;
          } else {
            basePriceCents = 0; // 次の recalc で DOM から取り直す
          }
          // 価格要素の再描画を待ってから再計算
          setTimeout(recalc, 50);
        });
      } catch (e) { /* ignore */ }
    }

    // ---- 公開 API ----
    window.SmolabCustomize = {
      isActive: true,
      // 全軸 (ベース含む): [{ axis, group, value, price(円), isBase }]
      getSelection: function () {
        return collectSelection().map(function (s) {
          return { axis: s.axis, group: s.group, value: s.value, price: s.price, isBase: s.isBase };
        });
      },
      getBaseYen: function () { return toYen(getBaseCents()); },
      getExtraYen: function () { return toYen(extraCents(collectSelection())); },
      // 本体 + 追加料金 (円)
      getTotalYen: function () {
        var selection = collectSelection();
        return toYen(getBaseCents() + extraCents(selection));
      },
      // カートに追加するアドオン variant: [{ id, price(円), axisName, label }]
      getAddonItems: function () {
        return nonBase(collectSelection()).map(function (s) {
          return { id: s.variantId, price: s.price, axisName: s.group, label: s.value };
        });
      },
    };

    // ---- submit 横取り → 成立したら送信ロック解除 ----
    if (form) {
      bindSubmit(form, productFormEl, root, collectSelection, productHandle);
      unlockForm(form);
    }

    recalc();
  }

  // Dawn product-form.js の loading / error 表示を同等に再現
  function makeUi(form, productFormEl) {
    var scope = productFormEl || form;
    var submitButton = scope.querySelector('[type="submit"]') || form.querySelector('button[type="submit"]');
    var spinner = submitButton ? submitButton.querySelector('.loading__spinner') : null;
    var errorWrapper = scope.querySelector('.product-form__error-message-wrapper');
    var errorText = errorWrapper ? errorWrapper.querySelector('.product-form__error-message') : null;
    var hideErrors = productFormEl ? productFormEl.dataset.hideErrors === 'true' : false;

    return {
      isBusy: function () {
        return !!submitButton && submitButton.getAttribute('aria-disabled') === 'true';
      },
      setLoading: function (on) {
        if (!submitButton) return;
        if (on) {
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.classList.add('loading');
          if (spinner) spinner.classList.remove('hidden');
        } else {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        }
      },
      showError: function (message) {
        if (hideErrors || !errorWrapper) {
          if (message) alert(message);
          return;
        }
        errorWrapper.toggleAttribute('hidden', !message);
        if (message && errorText) errorText.textContent = message;
      },
    };
  }

  function bindSubmit(form, productFormEl, root, collectSelection, productHandle) {
    var ui = makeUi(form, productFormEl);

    // カート追加後はカートページへ遷移するため loading 表示のまま離れる。ブラウザバックで
    // bfcache (戻る/進むキャッシュ) から復元されると loading のまま戻ってくるので、復元時に解除する
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) {
        ui.setLoading(false);
        ui.showError(false);
      }
    });

    // document のキャプチャ段階で受けることで、product-form.js の submit ハンドラより確実に先に動く
    document.addEventListener('submit', function (event) {
      if (event.target !== form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (ui.isBusy()) return;

      ui.showError(false);
      ui.setLoading(true);

      var fd = new FormData(form);
      var variantId = parseInt(fd.get('id'), 10) || 0;
      var quantity = parseInt(fd.get('quantity'), 10);
      if (!quantity || quantity < 1) quantity = 1;

      if (!variantId) {
        ui.setLoading(false);
        ui.showError((window.variantStrings && window.variantStrings.unavailable) || '商品を選択してください');
        return;
      }

      // 既存 form の properties[...] (ギフト用など) を引き継ぐ。自前の hidden は選択状態から再構築する
      var baseProps = {};
      fd.forEach(function (value, key) {
        if (typeof value !== 'string' || value === '') return;
        var m = key.match(/^properties\[(.+)\]$/);
        if (m) baseProps[m[1]] = value;
      });
      form.querySelectorAll('input[data-smolab-prop]').forEach(function (el) {
        var m = el.name.match(/^properties\[(.+)\]$/);
        if (m) delete baseProps[m[1]];
      });

      var all = collectSelection();
      var selection = nonBase(all);
      var items = [];
      var parent = { id: variantId, quantity: quantity, properties: baseProps };

      // 構成の明細 (ベース = 変更なし も含む全軸) を親の properties に載せる → カート/注文/比較リストに表示される
      all.forEach(function (s) {
        if (s.group) parent.properties[s.group] = s.display;
      });

      if (selection.length > 0) {
        // 親子を結び付けるグループ ID (カート内で一意)
        var group = productHandle + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 6);
        parent.properties._smolab_group = group;
        // 親に「期待する子」の署名 (variantId:sku|...) を持たせ、カート側で欠落・重複・想定外を照合できるようにする
        parent.properties._smolab_sel = selection.map(function (s) { return s.variantId + ':' + (s.sku || ''); }).join('|');
        selection.forEach(function (s) {
          items.push({
            id: s.variantId,
            quantity: quantity,
            properties: { _smolab_parent: group, _smolab_pc: productHandle, _smolab_axis: s.group, _smolab_sku: s.sku || '' },
          });
        });
      }
      if (Object.keys(parent.properties).length === 0) delete parent.properties;
      items.unshift(parent);

      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
      fetch(addUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          return response.json().then(function (data) { return { ok: response.ok, data: data }; });
        })
        .then(function (res) {
          var data = res.data || {};
          if (!res.ok || data.status) {
            var message = data.description || data.message || (window.cartStrings && window.cartStrings.error) || 'カートに追加できませんでした';
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'pc-customize',
                productVariantId: String(variantId),
                errors: data.errors || data.description,
                message: data.message,
              });
            }
            ui.showError(message);
            ui.setLoading(false);
            return;
          }
          // cart_type=page: カートページへ遷移 (loading 表示は遷移まで維持)
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(function (e) {
          console.error('[pc-customize] add to cart failed', e);
          ui.showError((window.cartStrings && window.cartStrings.error) || 'カートに追加できませんでした');
          ui.setLoading(false);
        });
    }, true);
  }

  function boot() {
    document.querySelectorAll('[data-pc-customize]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
